"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CounterLabel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const labelStyle = {
    margin: 0,
    textAlign: 'right',
    lineHeight: '22px',
    padding: '0 5px',
    whiteSpace: 'nowrap',
};
function CounterLabel(props) {
    const { children, style = {} } = props;
    return (0, jsx_runtime_1.jsx)("p", { style: { ...labelStyle, ...style }, children: children });
}
exports.CounterLabel = CounterLabel;
